import {
    ChangeDetectionStrategy,
    Component,
    inject,
    ViewEncapsulation,
    OnInit,
    DestroyRef,
    ViewChild,
} from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import {
    IOnboardingCompletionStep,
    IOnboardingCompletionUserStep,
    ITempCompletionSaveData,
} from '../fi-onboarding-completion';
import { FiOnboardingCompletionStateType } from '../fi-onboarding-completion-enums';
import { FiDialogCloseReason } from '@fi-shared/fi-dialogs/fi-dialogs-close-reason';
import { Subject } from 'rxjs';
import { FiOnboardingStepCompletionComponent } from '../fi-onboarding-step-completion/fi-onboarding-step-completion.component';
import { FiOnboardingStepCompletionDialogState } from './fi-onboarding-step-completion-dialog-state.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

interface IFiOnboardingStepCompletionDialogData {
    onboardingId: number;
    userId: number;
    saveTempProgress$?: Subject<ITempCompletionSaveData>;
    step: IOnboardingCompletionStep;
    userCompletionStep: IOnboardingCompletionUserStep;
    nextStepCompletionState: FiOnboardingCompletionStateType | undefined;
    isReportMode?: boolean;
}

@Component({
    selector: 'fi-onboarding-step-completion-dialog',
    templateUrl: './fi-onboarding-step-completion-dialog.component.html',
    styleUrl: './fi-onboarding-step-completion-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-step-completion-dialog' },
    standalone: false,
    providers: [FiOnboardingStepCompletionDialogState],
})
export class FiOnboardingStepCompletionDialogComponent
    extends FiDialogsContentBase<IFiOnboardingStepCompletionDialogData, IOnboardingCompletionUserStep>
    implements OnInit
{
    protected readonly dialogState = inject(FiOnboardingStepCompletionDialogState);
    private readonly fiStateService = inject(FiStateService);
    private readonly destroyRef = inject(DestroyRef);

    @ViewChild('onboardingStepCompletion') onboardingStepCompletionComponent: FiOnboardingStepCompletionComponent;

    public ngOnInit(): void {
        this.dialogState.init({
            onboardingId: this.data.onboardingId,
            userId: this.data.userId,
            step: this.data.step,
            userCompletionStep: this.data.userCompletionStep,
            nextStepCompletionState: this.data.nextStepCompletionState,
            isReportMode: this.data.isReportMode,
        });

        this.fiStateService.onFiStateGo$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.dialogRef.close();
        });
    }

    protected onCloseButtonClick(): void {
        if (this.dialogState.isReviewMode()) {
            this.dialogState.exitQuizReviewMode();
            return;
        }
        if (this.dialogState.isReportMode()) {
            this.closeDialog();
        }
        this.onboardingStepCompletionComponent.saveTempProgress(true);
    }

    protected closeDialog(): void {
        this.dialogRef.close({
            reason: FiDialogCloseReason.YesButton,
            value: this.dialogState.userCompletionStep(),
        });
    }
}
